import ProductTour from '../components/productTours/Tour';

export default function ProductTourProvider({ children }) {
  return <ProductTour>{children}</ProductTour>
}
